export default __webpack_public_path__ + "static/media/twitterWhite.6578e16b.svg";